/**
 * GlobalFilters - Componente de Filtros Globais para Dashboard Inside Sales
 * Permite filtrar dashboards por ano e mês
 */
import React from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import { FiFilter } from "react-icons/fi";
import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";

// Registrar locale português
registerLocale("pt-BR", ptBR);

const GlobalFilters = ({ filters, onFiltersChange }) => {
  // Meses do ano
  const months = [
    { value: null, label: "Todos os meses" },
    { value: 1, label: "Janeiro" },
    { value: 2, label: "Fevereiro" },
    { value: 3, label: "Março" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Maio" },
    { value: 6, label: "Junho" },
    { value: 7, label: "Julho" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Setembro" },
    { value: 10, label: "Outubro" },
    { value: 11, label: "Novembro" },
    { value: 12, label: "Dezembro" },
  ];

  // Converte ano para Date para o DatePicker
  const selectedYear = new Date(filters.year, 0, 1);

  const handleYearChange = (date) => {
    if (date) {
      const year = date.getFullYear();
      onFiltersChange({ ...filters, year });
    }
  };

  const handleMonthChange = (e) => {
    const month = e.target.value === "" ? null : parseInt(e.target.value);
    onFiltersChange({ ...filters, month });
  };

  return (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Body className="p-3">
        <Row className="align-items-center">
          <Col xs="auto">
            <div className="d-flex align-items-center">
              <FiFilter className="text-primary me-2" size={20} />
              <h6 className="mb-0 fw-bold text-dark">Filtros Globais</h6>
            </div>
          </Col>
          <Col xs={12} md="auto" className="mt-3 mt-md-0">
            <Form.Group className="mb-0">
              <Form.Label className="mb-1 small text-muted">Ano</Form.Label>
              <DatePicker
                selected={selectedYear}
                onChange={handleYearChange}
                showYearPicker
                dateFormat="yyyy"
                yearItemNumber={12}
                locale="pt-BR"
                className="form-control form-control-sm"
                wrapperClassName="d-block"
                minDate={new Date(2015, 0, 1)}
                maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md="auto" className="mt-3 mt-md-0">
            <Form.Group className="mb-0">
              <Form.Label className="mb-1 small text-muted">Mês</Form.Label>
              <Form.Select
                value={filters.month === null ? "" : filters.month}
                onChange={handleMonthChange}
                className="form-select-sm"
                style={{ minWidth: "160px" }}
              >
                {months.map((month) => (
                  <option key={month.label} value={month.value === null ? "" : month.value}>
                    {month.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md className="mt-3 mt-md-0">
            <small className="text-muted">
              {filters.month !== null 
                ? `Exibindo dados de ${months.find(m => m.value === filters.month)?.label} ${filters.year}`
                : `Exibindo dados de todos os meses de ${filters.year}`
              }
            </small>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default GlobalFilters;
